import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { cn } from '../../utils/helper';

function CommonPopover({
  label,
  children,
  contentClassName,
  className,
  containerClassName,
  anchor = 'bottom'
}) {
  return (
    <Popover className="relative">
      <PopoverButton
        className={`${className} inline-flex items-center justify-center font-medium hover:shoorah-primary focus:outline-none `}
      >
        {label}
      </PopoverButton>
      <PopoverPanel
        anchor={anchor}
        className={`${contentClassName} absolute z-10 p-2 rounded-md dark:bg-shoorah-darkBgColor dark:text-white bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none `}
      >
        {children}
      </PopoverPanel>
    </Popover>
  );
}

export default CommonPopover;
